/**
 * T109: Tags Route
 * Route for tags management page
 */

import { createFileRoute } from '@tanstack/react-router'
import { TagsPage } from '@/pages/settings/tags-page'

export const Route = createFileRoute('/_authenticated/settings/tags')({
  component: TagsPage,
})
